import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/ValesGasolina/valesGasolina';
import ValePreview from './ValePreview';

const mstp = state => {
    return {...state.valesGasolina}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ValePreview)